import React, { CSSProperties } from 'react';
import { Button, Dropdown, Menu, Popup } from 'semantic-ui-react';
import { imprimirFormaDePago } from '../../utilidades';
import { FiltroEsDeudor, FiltroSede } from '../tipos';

interface Props {
    cantidadDeRecordatorios: number;
    diaDePago: number;
    formaDePago: 'cheque' | 'pagare';
    filtroDeudores: FiltroEsDeudor;
    año: number | 'todos';
    sede: FiltroSede;
    cargando: boolean;
    alElegirDiaDePago(dia: number): void;
    alElegirFormaDePago(formaDePago: 'cheque' | 'pagare'): void;
    alElegirFiltroDeudores(filtroDeudores: FiltroEsDeudor): void;
    alElegirAño(año: number | 'todos'): void;
    alElegirSede(sede: FiltroSede): void;
    alPresionarRecargar(): void;
    alPresionarCorreos(): void;
}

const styleMenuItem: CSSProperties = { paddingLeft: '5px' };

const nombreSede: Record<FiltroSede, string> = {
    'alameda': 'Solo Alameda',
    'san-fernando': 'Solo San Fernando',
    'uchile': 'Solo U. de Chile',
    'todos': 'Cualquier sede',
};

const MenuTabla: React.FunctionComponent<Props> = props => {
    const {
        cantidadDeRecordatorios,
        cargando,
        alPresionarRecargar,
        alPresionarCorreos,
        diaDePago,
        formaDePago,
        filtroDeudores,
        año,
        sede,
        alElegirDiaDePago,
        alElegirFormaDePago,
        alElegirFiltroDeudores,
        alElegirAño,
        alElegirSede,
    } = props;

    return (
        <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Button
                            basic
                            icon='refresh'
                            loading={cargando}
                            onClick={alPresionarRecargar}
                        />
                    }
                    content='Recargar'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={<Button basic icon='mail outline' onClick={alPresionarCorreos} />}
                    content='Mostrar correos'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={imprimirFormaDePago(formaDePago)} item>
                    <Dropdown.Menu>
                        <Dropdown.Item key={'pagare'} onClick={() => alElegirFormaDePago('pagare')}>
                            Pagaré
                        </Dropdown.Item>
                        <Dropdown.Item key={'cheque'} onClick={() => alElegirFormaDePago('cheque')}>
                            Cheque
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Dropdown
                            fitted='vertically'
                            text={año !== 'todos' ? año.toString() : 'Cualquier año'}
                            item
                        >
                            <Dropdown.Menu>
                                {[2019, 2020, 2021, 2022, 2023, 2024, 2025, undefined].map(
                                    añoElegido => (
                                        <Dropdown.Item
                                            key={añoElegido || 'todos'}
                                            onClick={() => alElegirAño(añoElegido || 'todos')}
                                        >
                                            {añoElegido !== undefined
                                                ? añoElegido.toString()
                                                : 'Cualquiera'}
                                        </Dropdown.Item>
                                    ),
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    content='Forma de pago'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={diaDePago.toString() + ' de cada mes'} item>
                    <Dropdown.Menu>
                        {[5, 10, 15, 20, 25, 30].map(dia => (
                            <Dropdown.Item key={dia} onClick={() => alElegirDiaDePago(dia)}>
                                {dia.toString()}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={imprimirFiltroDeudores(filtroDeudores)} item>
                    <Dropdown.Menu>
                        {(['todos', 'deudores', 'noDeudores'] as FiltroEsDeudor[]).map(filtro => (
                            <Dropdown.Item
                                key={filtro}
                                onClick={() => alElegirFiltroDeudores(filtro)}
                                content={imprimirFiltroDeudores(filtro)}
                            />
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Dropdown fitted='vertically' text={nombreSede[sede]} item>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            content={nombreSede.todos}
                            onClick={() => alElegirSede('todos')}
                        />
                        <Dropdown.Item
                            content={nombreSede.alameda}
                            onClick={() => alElegirSede('alameda')}
                        />
                        <Dropdown.Item
                            content={nombreSede['san-fernando']}
                            onClick={() => alElegirSede('san-fernando')}
                        />
                        <Dropdown.Item
                            content={nombreSede.uchile}
                            onClick={() => alElegirSede('uchile')}
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Item>

            <Menu.Item position='right'>{cantidadDeRecordatorios} apoderados</Menu.Item>
        </Menu>
    );
};

const mapaFiltroDeudores: Record<FiltroEsDeudor, string> = {
    deudores: 'Solo deudores',
    noDeudores: 'No deudores',
    todos: 'Todos',
};

function imprimirFiltroDeudores(filtroDeudores: FiltroEsDeudor) {
    return mapaFiltroDeudores[filtroDeudores];
}

export default MenuTabla;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/RecordatoriosDePago/componentes/MenuTabla.tsx